import { useEffect, useState } from "react";

const KEY = "ntv_offer_deadline";
const WINDOW_MS = 15 * 60 * 1000; // rolling 15-minute evergreen welcome offer

function getDeadline() {
  let d = Number(sessionStorage.getItem(KEY) || 0);
  if (!d || d <= Date.now()) {
    d = Date.now() + WINDOW_MS;
    sessionStorage.setItem(KEY, String(d));
  }
  return d;
}

export const useCountdown = () => {
  const [remaining, setRemaining] = useState(() => getDeadline() - Date.now());
  useEffect(() => {
    const tick = () => setRemaining(Math.max(0, getDeadline() - Date.now()));
    tick();
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, []);
  const total = Math.max(0, Math.floor(remaining / 1000));
  const mm = String(Math.floor(total / 60)).padStart(2, "0");
  const ss = String(total % 60).padStart(2, "0");
  return { mm, ss, total };
};

export const CountdownPill = ({ className = "" }) => {
  const { mm, ss } = useCountdown();
  return (
    <span data-testid="countdown-timer" className={`tabular-nums ${className}`}>
      {mm}:{ss}
    </span>
  );
};

// Counts down to a fixed ISO deadline (e.g. the welcome-trial end). Returns a
// human string ("5h 12m" / "42:07") and whether it has expired.
export const useDeadlineCountdown = (iso) => {
  const target = iso ? new Date(iso).getTime() : 0;
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    if (!target) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [target]);
  const ms = Math.max(0, target - now);
  const totalSec = Math.floor(ms / 1000);
  const h = Math.floor(totalSec / 3600);
  const m = Math.floor((totalSec % 3600) / 60);
  const s = totalSec % 60;
  let text;
  if (!target) text = "";
  else if (h >= 1) text = `${h}h ${String(m).padStart(2, "0")}m`;
  else text = `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
  return { text, expired: !!target && ms <= 0, ms };
};
